import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

import featherlight from "featherlight";
import Swiper from 'swiper/bundle'; // import Swiper JS ALL

/*
 * Common
*/

const root = document.querySelector(':root');
root.style.setProperty( "--hh", $("header").innerHeight() );
root.style.setProperty( "--fh", $("footer").innerHeight() );




// Single
const postSwiper = new Swiper('.post-swiper', {
  slidesPerView: 1,
  spaceBetween: 18,
  centeredSlides: false,
  /*
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  */
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 1,
      centeredSlides: true,
    }
  }
});

// Hero
const heroSwiper = new Swiper('.hero-swiper', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});


/*
 * Single product
 */
$(function() {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function(){
    var w = $(window).width();
    if (w <= 767.98) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('#single-product-gallery', {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});

const SingleProductSubgallerySwiper = new Swiper('#single-product-subgallery', {
  slidesPerView: "auto",
  spaceBetween: 18,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: "auto",
      spaceBetween: 48,
    }
  }
});
